import { render, staticRenderFns } from "./seach-button.component.vue?vue&type=template&id=12ad0dc7&scoped=true"
import script from "./seach-button.component.vue?vue&type=script&lang=js"
export * from "./seach-button.component.vue?vue&type=script&lang=js"
import style0 from "./seach-button.component.vue?vue&type=style&index=0&id=12ad0dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ad0dc7",
  null
  
)

export default component.exports